import { create } from "zustand";

/**
 * Which inline editor (if any) is currently open in the Chronology tab.
 * Modeled as a discriminated union so an "adding" and "editing" state can
 * never be active at the same time.
 */
export type ChronologyEditorState =
  | { mode: "idle" }
  | { mode: "adding" }
  | { mode: "editing"; eventId: string };

interface ChronologyStore {
  editor: ChronologyEditorState;
  startAdding: () => void;
  startEditing: (eventId: string) => void;
  closeEditor: () => void;
  /** Event id to highlight briefly after creation from the doc viewer. */
  highlightedEventId: string | null;
  setHighlightedEventId: (id: string | null) => void;
}

export const useChronologyStore = create<ChronologyStore>((set) => ({
  editor: { mode: "idle" },
  startAdding: () => set({ editor: { mode: "adding" } }),
  startEditing: (eventId: string) =>
    set({ editor: { mode: "editing", eventId } }),
  closeEditor: () => set({ editor: { mode: "idle" } }),
  highlightedEventId: null,
  setHighlightedEventId: (id) => set({ highlightedEventId: id }),
}));
